import { Icons } from "../../../../../../../shared/icons/icons";

export default function ClinicNote({ content }) {
  return (
    <div className="clinic-section__note reveal-on-scroll reveal-on-scroll--up reveal-delay-2">
      <div className="clinic-section__note-icon">
        <Icons.Flower2 />
      </div>

      <div>
        <strong>
          {content.noteTitle} <em>{content.noteAccent}</em>
        </strong>
      </div>

      <span />

      <p>{content.noteText}</p>
    </div>
  );
}